<div class="container">
  <span *ngIf="recipe?.images?.length > 0">
    <g-img [src]="recipe?.images[0]?.url"></g-img>
  </span>
  <div class="text-container">
    <span class="title">{{recipe?.name}}</span>

    <span class="subtext">Servings: {{recipe?.yield}}</span>
  </div>
</div>